import { NAME_LOCALSTORAGE_TOKEN } from "../config/configBase";

export function infoCod() {
    const tokenString = localStorage.getItem(NAME_LOCALSTORAGE_TOKEN);
    const userToken = JSON.parse(tokenString);
    return userToken
}